import Keypad from './buttons/keypad';
import PropTypes from 'prop-types';
import styles from 'styles/Header.module.scss';

const Navbar = ({ navbarType = 'landing' }) => {
    return (
        <div className={styles.sHeaderNavbar}>
            <div className={styles.sHeaderContainer}>
                <div className={styles.sHeaderNavbarRow}>
                    <Keypad navbarType={navbarType} />
                </div>
            </div>
        </div>
    );
};

Navbar.propTypes = {
    navbarType: PropTypes.string
};

export default Navbar;
